// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-remote {
  position: relative;
}

  .animated-remote--block {
    display: block;
  }

  .animated-remote--fill {
    display: unset;
  }

  .animated-remote--fill .animated-remote__state {
      display: unset;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
